module.exports = __webpack_public_path__ + "img/futsal.a47bf880.svg";